import React, { useEffect, useMemo, useState } from 'react'
import ListContainer from '../../../list'
import { FormActionButtons, Switch } from '../../../../components'
import { Button, Link, Tooltip, makeStyles } from '@material-ui/core';
import { getI18n, getI18nFormattedMessage } from '../../../../utils/intl';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import {
  GRID_ROWS_PER_PAGE_DEFAULT_OPTION,
  UPDATE_APIS_FOR_API_PLANS_SUCCESS,
} from '../../../../constants';
import { FilterByName, HeaderActionButtons } from '../controls';
import styles from "./styles";
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { fetchApisForApiPlans, updateApisForApiPlans } from '../../../../actions/apiPlans';
import {
  getApiPlansLoading, getApisResultsForApiPlans, getApisUpdateForApiPlans,
  getTotalElementsApisForApiPlans, getTotalPagesApisForApiPlans,
} from '../../../../reducers/apiPlans';
import WarningIcon from "@material-ui/icons/Warning";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { getStatusColor, getStatusLabel } from '../../../Api/List/utils';
import { cloneDeep, every, map } from 'lodash';
import { APIS_ADD_ACCESS, APIS_REMOVE_ACCESS, compareArrays } from '../utils';
import { compose } from 'recompose';

export const Apis = (props) => {
  const {
    apiPlanUuid,
    setCurrentTab,
    setCurrentTabDirty,
    isLoading,
    apisResultsForApiPlans,
    apisTotalElementsForApiPlans,
    apisTotalPagesForApiPlans,
    isUpdateApisForApiPlansSuccess,
    setAlertMessages,
  } = props

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
  const [filterByApiName, setFilterByApiName] = useState('');
  const [appliedFilterByApiName, setAppliedFilterByApiName] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [changeMode, setChangeMode] = useState(APIS_REMOVE_ACCESS);
  const [currentApiRows, setCurrentApiRows] = useState([]);
  const [assignedApis, setAssignedApis] = useState([]);
  const [unAssignedApis, setUnAssignedApis] = useState([]);
  const [payload, setPayload] = useState({
    page: page,
    size: rowsPerPage,
    name: filterByApiName,
    apiPlanApiAccessStatus: "ASSIGNED",
  })

  const params = useParams();
  const dispatch = useDispatch();
  const currentTab = params?.tabName;
  const isCurrentTab = currentTab === 'apis';

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const isApisRemoveAccess = changeMode === APIS_REMOVE_ACCESS;
  const isApisAddAccess = changeMode === APIS_ADD_ACCESS;

  const assignedApisFromApi = isApisRemoveAccess && apisResultsForApiPlans &&
    apisResultsForApiPlans?.map(api => api?.apiUuid);

  useEffect(() => {
    setAssignedApis(assignedApisFromApi || []);
    setUnAssignedApis(assignedApisFromApi || []);
  }, [apisResultsForApiPlans]);


  useEffect(() => {
    if (isCurrentTab) {
      setFilterByApiName('');
      setAppliedFilterByApiName('');
      setPage(0);
      setCurrentTab('add-api-plans-apis-tab');
      setCurrentTabDirty(false);
      setSelectedRows([]);
      setChangeMode(APIS_REMOVE_ACCESS)
      setPayload({
        ...payload,
        apiPlanApiAccessStatus: "ASSIGNED",
      })
    }
  }, [isCurrentTab])

  const onAccessToggle = (val, uuid) => {
    setAssignedApis(prevAssignedApis =>
      val
        ? [...prevAssignedApis, uuid]
        : prevAssignedApis.filter(apiUuid => apiUuid !== uuid),
    );
  };

  const getListColumns = ({ getI18nFormattedMessage }) => [{
    id: 'apiName',
    label: getI18nFormattedMessage("label.organization.apiaccess.apiname"),
    minWidth: 200,
    format: (item) => {
      return (
        (<Link underline="none" className={classes.link} href={`/publish/apis/details/${item.apiUuid}`} target='_blank'>
          {item.apiName}
        </Link>)
      )
    },
    value: ({ apiName, apiUuid } = {}) => ({ apiName, apiUuid }),
  },
  {
    id: 'portalStatus',
    label: getI18nFormattedMessage("label.application.details.apis.status.column.title"),
    minWidth: 50,
    value: (item) => {
      const { portalStatus } = item;
      const status = getStatusLabel(portalStatus);
      const statusIconStyle = {
        fill: getStatusColor(portalStatus),
      };
      return (
        <span>
          <FiberManualRecordIcon
            size="0.82em" key={item.uuid} style={statusIconStyle} className={classes.statusIcon} />
          {status === 'Deprecated' || status === 'Disabled' ?
            <span> {status}
              <Tooltip
                title={status === 'Deprecated' ?
                  getI18nFormattedMessage('label.application.details.deprecated.api.locked')
                  :
                  getI18nFormattedMessage('label.application.details.disabled.api.locked')}
                arrow
                placement="top"
              >
                <WarningIcon className={classes.warningIcon} />
              </Tooltip>
            </span>
            :
            <span>{status}</span>
          }
        </span>);
    },
  },
  {
    id: 'apiPlanApiAccessStatus',
    label: getI18nFormattedMessage("label.assign"),
    minWidth: 50,
    format: (item) =>

    (<Switch
      id={`${item.apiUuid}-access`}
      onChange={(val) => onAccessToggle(val, item.apiUuid)}
      checked={assignedApis?.includes(item.apiUuid)}
    />

    ),
    value: (item) => (item),

  },
  ];

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    setPayload({ ...payload, page: newPage })
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setPayload({ ...payload, size: newRowsPerPage })
  };


  const intl = getI18n(useIntl());

  const handleChange = (value, filterType) => {
    switch (filterType) {
      case 'filterByApiName':
        setFilterByApiName(value);
        break;
      default:
        break;
    }
  }

  const handleBlur = () => {
    setAppliedFilterByApiName(filterByApiName);
    if (appliedFilterByApiName !== filterByApiName) {
      setPage(0);
      setPayload({ ...payload, name: filterByApiName });
    }
  }

  useEffect(() => {
    if (apiPlanUuid) {
      dispatch(fetchApisForApiPlans(apiPlanUuid, {
        page: page,
        size: rowsPerPage,
        name: filterByApiName,
        apiPlanApiAccessStatus: isApisRemoveAccess ? "ASSIGNED" : "NOT_ASSIGNED",
      }))
    }
  }, [payload, apiPlanUuid, isApisRemoveAccess])

  const onAssignToggle = () => {
    setAssignedApis([
      ...assignedApis,
      ...selectedRows.filter(uuid => !assignedApis.includes(uuid)),
    ]);
  };

  const onUnAssignToggle = () => {
    setAssignedApis(assignedApis.filter(apiUuid => !selectedRows.includes(apiUuid)));
  };

  const isApisTabDirty = useMemo(() => {
    if (apiPlanUuid && isCurrentTab) {
      return compareArrays(assignedApis, unAssignedApis);
    }
    return false;
  }, [apiPlanUuid, assignedApis, unAssignedApis, isCurrentTab]);

  useEffect(() => {
    setCurrentTabDirty(isApisTabDirty);
  }, [isApisTabDirty]);

  const handleAddApis = () => {
    setChangeMode(APIS_ADD_ACCESS);
    setPage(0);
    setFilterByApiName("");
    setRowsPerPage(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
    setPayload({
      ...payload,
      apiPlanApiAccessStatus: "NOT_ASSIGNED",
    })
  }

  const handleCancel = () => {
    const resetApisTabSettings = () => {
      setSelectedRows([]);
      setFilterByApiName("");
      setPage(0);
      setRowsPerPage(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
    }
    if (isApisRemoveAccess && apiPlanUuid && isCurrentTab && isApisTabDirty) {
      resetApisTabSettings();
      setPayload({ ...payload, apiPlanApiAccessStatus: "ASSIGNED" })
    } else if (isApisAddAccess && apiPlanUuid && isCurrentTab && isApisTabDirty) {
      resetApisTabSettings();
      setPayload({ ...payload, apiPlanApiAccessStatus: "NOT_ASSIGNED" })
    } else if (isApisAddAccess && !isApisTabDirty) {
      setChangeMode(APIS_REMOVE_ACCESS);
      resetApisTabSettings();
      setPayload({ ...payload, apiPlanApiAccessStatus: "ASSIGNED" })
    }
  }

  useEffect(() => {
    const rowsData = map(apisResultsForApiPlans &&
      apisResultsForApiPlans, (item) => ({ uuid: item.apiUuid, ...item }));
    setCurrentApiRows(cloneDeep(rowsData));
  }, [apisResultsForApiPlans])

  const assignedApisPayload = assignedApis?.map((apiUuid) => {
    return {
      uuid: apiUuid,
    }
  })

  const unAssignedApisFiltered = unAssignedApis && unAssignedApis?.filter(apiUuid =>
    !assignedApis?.includes(apiUuid)) || [];
  const unAssignedApisPayload = unAssignedApisFiltered && unAssignedApisFiltered?.map(apiUuid => {
    return {
      uuid: apiUuid,
    }
  });

  const decideAccessModePayload = useMemo(() => {
    if (isApisAddAccess) {
      return assignedApisPayload;
    } else if (isApisRemoveAccess) {
      return unAssignedApisPayload;
    }
  }, [changeMode, assignedApisPayload, unAssignedApisPayload])

  const handleSaveApis = () => {
    setAlertMessages({
      message: "",
      variant: "",
      status: false,
    })
    setPage(0);
    setRowsPerPage(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
    setFilterByApiName("");
    setSelectedRows([]);
    dispatch(updateApisForApiPlans(decideAccessModePayload, apiPlanUuid, changeMode));
  }

  useEffect(() => {
    if (isUpdateApisForApiPlansSuccess) {
      setChangeMode(APIS_REMOVE_ACCESS);
      dispatch({ type: UPDATE_APIS_FOR_API_PLANS_SUCCESS, payload: "" });
      setPayload({ ...payload, apiPlanApiAccessStatus: "ASSIGNED" });
    }
  }, [isUpdateApisForApiPlansSuccess]);

  const disableAdd = every(selectedRows, uuid => assignedApis?.includes(uuid));
  const disableRemove = every(selectedRows, uuid => !assignedApis?.includes(uuid));

  return (
    <div>
      {
        apisResultsForApiPlans &&
        <ListContainer
          listPageId='add-api-plans-apis-list'
          showListHeader={true}
          isLoading={isLoading}
          noResultsMessage={getI18nFormattedMessage('label.no.results')}
          filterAndSortContent={(
            <div className={classes.filtersContainer}>
              <FilterByName
                id="add-api-plans-apis-filter-by-name"
                fieldContainerClass={classes.fieldContainer}
                handleChange={(value) => handleChange(value, 'filterByApiName')}
                name={getI18nFormattedMessage("label.filter")}
                handleBlur={handleBlur}
                placeholder={intl.getI18nMessage("label.api.name")}
                value={filterByApiName}
              />
              {
                isApisRemoveAccess &&
                <Button
                  id='add-api-plans-add-api-button'
                  data-apim-test='add-api-plans-add-api-button'
                  className={classes.addApiButton}
                  variant='contained'
                  color='secondary'
                  onClick={handleAddApis}
                  disabled={isApisTabDirty}
                >
                  {intl.getI18nMessage("label.api.add")}
                </Button>
              }
            </div>
          )}
          columns={getListColumns({ getI18nFormattedMessage })}
          rows={currentApiRows}
          totalElements={apisTotalElementsForApiPlans}
          totalPages={apisTotalPagesForApiPlans}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          onChangePreviousPage={onChangePreviousPage}
          onChangeNextPage={onChangeNextPage}
          page={page}
          rowsPerPage={rowsPerPage}
          pageClass={classes.listContent}
          pageBodyClass={classes.pageBodyClass}
          pageFilterAndSortClass={classes.pageFilterAndSortClass}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          hasBulkActions={false}
          hasPaginationDisabled={isApisTabDirty || selectedRows.length > 0}
          bulkActionsContent={
            (<HeaderActionButtons
              {...props}
              id={'add-api-plan-apis-assignment'}
              fieldContainerClass={classes.fieldContainer}
              bulkActionsItemsCount={selectedRows.length}
              classes={classes}
              disableAdd={disableAdd}
              disableRemove={disableRemove}
              onAssign={onAssignToggle}
              onUnassign={onUnAssignToggle}
            />)
          }
        />
      }
      {
        (isApisTabDirty || isApisAddAccess) && (
          <FormActionButtons
            id='add-api-plans-apis-tab-action-buttons'
            nextText={intl.getI18nMessage('label.save.button')}
            onNextClick={handleSaveApis}
            onCancelClick={handleCancel}
            showCancel
            isContainerFooter
            isDisabled={!isApisTabDirty}
          />
        )
      }
    </div>
  )
}

const mapStateToProps = ((state) => ({
  isLoading: getApiPlansLoading(state),
  apisResultsForApiPlans: getApisResultsForApiPlans(state),
  apisTotalElementsForApiPlans: getTotalElementsApisForApiPlans(state),
  apisTotalPagesForApiPlans: getTotalPagesApisForApiPlans(state),
  isUpdateApisForApiPlansSuccess: getApisUpdateForApiPlans(state),
}))

export default compose(
  connect(mapStateToProps),
)(Apis);

Apis.propTypes = {
  setCurrentTab: PropTypes.func,
  setCurrentTabDirty: PropTypes.func,
  apiPlanUuid: PropTypes.string,
  isLoading: PropTypes.bool,
  apisResultsForApiPlans: PropTypes.array,
  apisTotalElementsForApiPlans: PropTypes.number,
  apisTotalPagesForApiPlans: PropTypes.number,
  isUpdateApisForApiPlansSuccess: PropTypes.string,
  setAlertMessages: PropTypes.object,
};
